/**
 * This class used for language translation - only english content
 */
 export class TranslateEn {
  /**
   * Header Menu and Sub Menu Data
   */
  public static headerMenu = {
    home: "Home",
    login: "LOGIN",
    aboutUpskill: "About Us",
    courses: "Courses",
    whatweoffer: "WHAT WE OFFER",
    empbenefits: "EMPLOYERS' BENEFITS",
    indbenefits: "INDIVIDUALS' BENEFITS",
    partnership: "PARTNERSHIPS",
    hiring: "HIRING",
    trainingfremp: "TRAINING FOR YOUR EMPLOYEES",
    funding: "FUNDING",
    othogminit: "OTHER PROGRAM AND INITIATIVES",
    hrconsult: "HR CONSULTATION",
    elatih: "E-LATIH",
    loginSubMenu: {
      individual: "INDIVIDUAL LOGIN",
      employerLogin: "EMPLOYER LOGIN",
      agencyLogin: "ADMIN LOGIN",
    },
    insights: "Resources",
    insightsSubMenu: {
      reportArticles: "Reports & Articles",
      skillFramework: "Industrial Skill Insights Framework",
      upskillinsights: "Upskilling Insights",
      upskillstatistics: "UpSkillMalaysia Statistics And Insights",
    },
    mediaGallery: "MEDIA GALLERY",
    contactUs: "Contact Us",
    // individual: "Individual Login",
    individual: "Individual",
    agencyLogin: "Admin Login",
    // trainingProviderLogin:"Course Provider Login",
    trainingProviderLogin:"Course Provider",
    faq: "FAQ",
    guidelines: "Guideline",
    individuals: "Individual",
    tp: "Course Provider",
    agency: "Agency",
    manual1: "Post Training Report & e-certificate",
    active_courses: "Active Courses",
    archived_courses: "Archived Courses",
    navigation: "Navigation",
    overview: "Overview",
    objectives: "Objectives",
    pillars: "Pillars & Focus Areas",
    elearning: "E-Learning",
    benefits: "Benefits",
    target: "Target Groups",
    gallery: "Gallery",
    satelliteevents: "Satellite Events",
    cimanual: "Brand Guidelines"
  };

  //Jobseeker Menu
  public static jobSeekerMenu = {
    home: "Home",
    courses: "Courses",
    archive_courses: "Archived Courses",
    jobSearch: "Job Search",
    jobs: "Jobs",
    appliedJobs: "Applied Jobs",
    interviewScheduledJobs: "Interview Scheduled Jobs",
    savedJobs: "Saved Jobs",
    jobFilters: "Job Filters",
    appliedCourses: "Applied Courses",
    satelliteEvents: "Satellite Events",
    myProfiles: "My Profile",
    employerChat: "Employer Chat",
    geofencingJobs: "Geofencing Jobs",
    myCertificate: "My Certificates",
  };

  /**
   * Footer menu, legislation and contact us
   */
  public static footerData = {
    menu: "MENU",
    mainPage: "Main Page",
    individualLogin: "Individual Login",
    employersLogin: "Employer Login",
    agencyLogin: "Agency Login",
    mohrandmofLogin: "MOHR & MOF login",
    adminLogin: "Admin login",
    legislation: "LEGALS",
    privacyPolicy: "Privacy Policy",
    pdpa: "PDPA",
    contactUS: "Contact US",
    pleaseContactUS: "If you require any further information, please contact us via email below :",
    taskforceEmail: "taskforce@nationaltrainingweek.gov.my",
    rights: "© 2023 National Training Week. All rights reserved.",
    navigation: "Navigation",
    home: "Home",
    aboutUs: "About Us",
    courses: "Courses",
    contact: "Contact",
    quickLinks: "Quick Links",
    disc: "Discussions",
    terms: "Terms & Conditions",
    support: "Customer Support",
    faq: "FAQs",
  };

  /**
   * Job Seeker Signup for data
   */
  public static jobseekerSignupFormData = {
    myBasicInfo: "My Basic Info",
    signupFree: "Sign Up for FREE to get Job Matches.",
    name: "Name",
    phoneNumber: "Phone Number",
    phoneNumberPH: "Enter your Phone Number",
    emailAddress: "Email Address",
    sampleEmail: "sample@email.com",
    icNumber: "IC Number",
    icNumberPH: "Enter your IC Number",
    createPassword: "Create Password",
    createPasswordPH: "Enter your Password",
    confirmPassword: "Confirm Password",
    confirmPasswordPH: "Enter your Password",
    fresher: "I have no work experience.",
    nationality : "Nationality",
    state : "State",
    other_country : "Other Country",
    otherCountryPH : "Country Name",
    passport : "Passport",
    passportPH:"Enter your passport number",
    dob : "Date of Birth",
    gender : "Gender",
    event : "Event Specific Information", 
    employment : 'Identification of Employment',
    organisation : 'Identification of Organization',
    declaration : 'I agree with ...',
    alternativeEmail : 'Alternative Email',
    alternativePhoneNumber : 'Alternative Phone Number',
    personalInfo : 'Personal Info',
    alternativeContact:"Alternative Contact",
    eventAndOrganization : 'Event & Organization',
    others : 'Others',
    // pswInstruction:
    //   "Use eight (8) or more characters with a mix of uppercase and lowercase letters, together with numbers and symbols.",
    pswInstruction:
      "Use eight (8) or more characters .",
    keySkills: "Key Skills",
    keySkillsPH: "Select Key Skills",
    add: "Add",
    conditionalQuestion: "Conditional Questions (For Course Matching)",
    targetGroupTitle: "What is your Target Group?",
    whichCategoryTitle: "Which Category do you want to Join?",
    chooseOption: "Choose Option",
    statethelocation:
      "State the Location of your preferred Placement or Training",
    currentlyUnemployed: "I have no work experience",
    agreeCondition: "I agree to the Terms and Conditions of HRD Corp",
    getStarted: "Get Started",
    agree: "I agree to HRD Corp's",
    terms: "Terms and Conditions",
    hrdf: "of HRD Corp.",
    candidatenamereq: "The Candidate Name field is required",
    phonenumreq: "The Phone Number field is required",
    phonecharreq: "The Phone Number field must be at least 10 characters",
    emailreq: "The Email ID field is required",
    emailexists: "Email-ID Already Exists!",
    icnumreq: "The IC Number field must be at least 12 characters",
    icnumexists: "IC Number Already Exists!",
    icnumcharreq: "The IC Number field must be at least 12 characters",
    passwordreq: "The Password field is required",
    passcharreq: "The Password field must be at least 8 characters",
    passcharnumreq:
      "The password must contain at least one uppercase, one lowercase letter, one number, and one special characte",
    confirmpassreq: "The Confirm Password field is required",
    passmatchreq: "Password Mismatched",
    keyskillreq: "The Key Skills field is required",
    coditionalreq: "Kindly select the questions",
    termscheckreq: "Kindly agree to the Terms and Conditions",
    conditionalquestion: "Conditional Questions (For Course Matching)",
    procedifdatacorrect: "Kindly proceed if the entered details are correct?",
    resumeChooseLabel: "Choose",
    uploadResume: "Upload Resume",
    format: "Supported Formats: PDF Only, Upto 2 MB",
    previous: "Previous",
    next: "Next",
    createAccount: "Create Account",
    currentstatus: "Current Status",
    selectlocationplaceholder: "Select Location",
    selectCurrentStatus: "Select Current Status",
    registrationsuccess:
      "Your registration is completed, please check your email for login credentials.",
    success: "Success",
    nameplaceholder: "Enter Name as per NRIC",
    register: "Register",
    tag: "Start your journey for lifelong skills development",
    agreeToReceive: "I agree to receive marketing and promotional email",
    mandatoryInfo: "Mandatory information",
  };

  /**
   * Home page content
   */
  public static homePageData = {
    title: "UPSKILLMALAYSIA",
    subTitle: "Upskill to Meet the Demands of Industry",
    description: "Unlock your potential with limitless learning opportunities",
    subdescription: "Register now and discover the power of knowledge",
    courses: "Courses",
    jobs: "Jobs",
    searchBoxPH: "Search",
    myFutureJobs: "MY FUTURE JOBS",
    myFutureJobsContent: "Job placements and hiring incentives",
    clickHere: "CLICK HERE",
    departmentOfLabour: "DEPARTMENT OF LABOUR",
    departmentOfLabourContent: "Employment related solutions",
    nhrc: "NATIONAL HUMAN RESOURCE CENTRE (NHRC)",
    nhrcContent: "Human resource advisory and consultancy",
    akpk: "AGENSI KAUNSELING & PENGURUSAN KREDIT (AKPK)",
    akpkContent: "Financial Literacy",
    mainObjective: "MAIN OBJECTIVES",
    centralisedInformation: "CENTRALISED INFORMATION",
    centralisedInformationContent:
      "Comprehensive Details Of Opportunities To Meet Your Individual Needs",
    jobOppertunity: "JOB OPPORTUNITIES",
    jobOppertunityContent:
      "Careers are matched according to the qualifications and interests of individuals",
    trainingMatching: "TRAINING MATCHING",
    trainingMatchingContent:
      "Appropriate course matching based on applicant's information",
    careerInsights: "CAREER INSIGHTS",
    careerInsightsContent:
      "Plan your career based on available updated statistics",
    ministriesandAgencies: "MINISTRIES & AGENCIES",
    whoShouldParticipate: "WHO SHOULD PARTICIPATE",
    individuals: "INDIVIDUALS",
    individualsContent:
      "Training Programmes To Increase Marketability For Income Generation",
    applyNow: "Enrol now",
    employers: "EMPLOYERS",
    employersContent:
      "Train employees or prospective employees to strengthen the business",
    ministriesAndAgencies: "MINISTRIES & AGENCIES",
    ministriesandAgenciesContent:
      "List of highly skilled training programmes that boost marketability potential",
    testimonals: "TESTIMONIALS",
    anIntegratedTitle: "AN INTEGRATED PORTAL THAT MEETS YOUR UNIQUE NEEDS",
    anIntegratedContent:
      "An Integrated portal for Malaysians , providing access to training programmes, job opportunities, entrepreneurship skills, advisories, career planning support, details on employment laws and other related information.",
    matching: "MATCHING",
    aiTitle: "ARTIFICIAL INTELLIGENCE",
    aiContent:
      "The Skills And Interests Of The Individual Are Matched Accurately To The Programme Or Job Requirement With Immediate Response",
    employerAd: "CALLING ALL EMPLOYERS",
    employerAdSub: "TO ADVERTISE THEIR VACANCIES",
    employerAdSub2: "Tap Into The Talent Pool And Training Incentives",
    individualAd: "CALLING ALL INDIVIDUALS",
    individualAdSub: "TO REGISTER THEIR PROFILES",
    individualAdSub2: "Apply For Jobs And Career Development Opportunities",
    benefits: "EMPLOYERS' BENEFIT",
    individualBenefits: "INDIVIDUALS",
    elatih: "E-LATIH",
    insights: "INSIGHTS",
    partnerships: "PARTNERSHIPS",
    jobplacement:"Job Placement",
    entregig:"Entrepreneurship / GIG",
    skillimpro:"Skills Upgrading / Job Retention",
    jobplacementdesc:"Obtain employment by participating in value added training based on industries' demand",
    entregigdesc:"Training programmes that increase employment marketability for income generation or freelance jobs.",
    skillimprodesc:" Improve specific skills and knowledge to boost income generation in various fields",
    centralizedInfo: "A one-stop information portal/hub for upskilling and reskilling programmes offered by ministries and agencies.",
    jobMatching: "A web-based instrument to assess an individual academics qualification degree to match a suitable placement opportunity.",
    courseMatching: "Explore your options, get matched to courses based on the individual profile.",
    tagline:"If you are looking for work and opportunities to get into the job market then we are here to help you! find all the latest opportunities, advisories and lots more.",
    availCourses: "Courses",
    trainingStats: "Course Providers",
    applications: "Applications",
    agency: "Agencies",
    searchKey: "Please Enter the keyword",
    areYou: "ARE YOU AN",
    employer: "EMPLOYER?",
    clickHereTo: "Click Here to Register",
    yourAccount: "Your Account",
    individual: "INDIVIDUAL?",
    certInfo: "Centralised Information",
    jobMatchingPlacement: "Job Matching & Placement",
    courseMatchingTitle: "Course Matching",
    explore: "Explore Top Courses",
    viewall: "View All",
    catagories: "Categories",
    catagoryDesc: "The UpskillMalaysia workforce components is our utmost important resources. We offer opportunities under three kinds of categories as well as other arrangements.",
    partnership1: "In ",
    partnership2: "partnership with",
    tab1: "Entrepreneurship / GIG",
    tab2: "Job Placement",
    tab3: "Skill Improvement",
    tagLine1: "",
    tagLine2: "",
    tagLine3: "",
    tagLine4: "",
    skills: "Skill Areas",
    skillsTitle: "Choose your preferred courses from the following Skill Areas",
    centralInfo: "Centralised Information",
    centralInfoSub: "Get the latest info on all upskilling and re-skilling programmes offered by government ministries and agencies on one integrated platform.",
    skillsRepo: "Skills Repository",
    skillsRepoSub: "Create a comprehensive record for all your professional skills, experiences, qualifications and trainings in one place.",
    courseMatch: "Course Matching",
    courseMatchSub: "Explore your options, recommended courses offered based on your profile.",
    feedBack: "What our users have to say",
    all: "All",
    noCourse: "No Course Found",
    slots: "Slots",
    click: "Click on the map to view",
    click_photos: "Click on the photos to view our social wall",
    available_seats: "Available Seats",
    unlimited_seats: "Unlimited Seats",
    foc: "FREE",
    enrolments: "Enrolments",
    registerNow: "Register Now",
    noEvent: "No Event Found",
    noPartners: "No Partners Found",
  };
  
  public static aboutUsPageData = {
    description: "About Us",
    subdescription: "Driving Malaysia’s training and development for a brighter future.",
  }

  public static agencyMedacData = {
    medacTitle: "Ministry of Entrepreneur Development & Cooperatives (MEDAC)",
    mainDescription:
      "Offering development initiatives through training and business skills to help those interested in becoming entrepreneurs",
    title1: "INSKEN Business Training",
    description: "Description:",
    content1:
      "Short term training that focuses on ‘knowledge’ techniques that guide entrepreneurs to establish and strengthen their day to day operations. This is to increase the ability of entrepreneurs in taking on the responsibilities of a senior manager and SME Management. The program covers aspects of financial management, marketing, operations and the use of technology to help entrepreneurs operate efficiently and effectively",
    title2: "Online Onboarding Coaching Programme (e-Board)",
    content2:
      "This program aims to strengthen the capabilities of local small and medium micro entrepreneurs in using online platforms through intensive guidance and ‘hand holding’ for 3 months",
    title3: "Agriculture Coaching Industry Development Programme (ACID)",
    content3:
      "Improving the entrepreneurial skills among youths and rural communities belonging to the B40 group through business training and guidance by implementing programs focused on agriculture",
    title4: "Program Keusahawanan Koperasi",
    content4:
      "Initiatives that help cooperatives in the affected sectors by heading towards new businesses through training and new skills",
    title5: "Program Tunas Usahawan Belia Bumiputera (TUBE)",
    content5:
      "This program targets Bumiputra youths between the ages of 18-30 who have a deep interest in getting involve in entrepreneurship especially those who have basic skills certificates from training institution",
    title6: "Young Entrepreneur Program",
    content6:
      "The program aims to strengthen participants from the stage of exploring good business ideas to systematically testing the potential of a viable business market. This program also help young entrepreneurs to formulate marketing strategies through digital marketing.",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static agencyKptData = {
    kptTitle: "Ministry of Higher Education (MOHE)",
    kptDescription:
      "Offering programs that give impact and added value to the skills of graduates who have just graduated in year 2019 to 2020",
    description: "Description:",
    title1: "Job Matching & Placement",
    content1:
      "Competitive and targeted skills improvement programs are given to put participants based on industry needs to ensure that the jobs offered can be implemented well.",
    title2: "Entrepreneurship Programme",
    content2:
      "Competent training that is able to improve the skills and knowledge of participants in the field of entrepreneurship and to be able to establish a start- up company with the help of financing provided by a recognized funding agency",
    title3: "Gig Economy Programme",
    content3:
      "Competent training programs that are able to help participants to generate income through Gig Economy or independent work aktivities",
    title4: "Program Reskilling & Upskilling",
    content4:
      "Skills programs and targeted skills upgrades are given to participants based on industry needs to ensure that participants are offered jobs with high starting salary or venture into entrepreneurship related to the training provided",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static agencyMotacData = {
    motacTitle: "Ministry of Tourism, Arts and Culture (MOTAC)",
    motacDescription:
      "Offering programs that focus on the development of art skills and entrepreneurship that will benefit the art and creative industry",
    description: "Description:",
    title1: "Community Skills Development",
    content1: "This program is open to all",
    list1: "1.Youths",
    list2: "2.B40category group in the cities or villages",
    list3: "3.Single mothers",
    list4: "4.The disabled (OKU)",
    list5: "5.Senior citizens,",
    list6: "6.Native indigenous ethnic community of Sabah & Sarawak",
    list7:
      "7.Employers, or individuals affected by the Covid19 pandemic outbreak that aims to make crafted heritage products as a source of income generation",
    title2: "Apprenticeship Skills Development",
    content2:
      "Offering new manpower training facilities consisting of youths, the unemployed and individuals by offering employment opportunities with selected craft entrepreneurs. This program helps craft entrepreneurs get a skilled workforce and ensures that the enterprises can operate continuously and more competitively.",
    title3: "Art Entrepreneurship Development Series",
    content3:
      "Art Entrepreneurship Development, SIRI, is an art entrepreneurship course by offering a solid understanding of business in performing arts.",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static agencyKbsData = {
    kbsTitle: "Ministry of Youth & Sports (MOYS)",
    kbsDescription:
      "Cultivate entrepreneurship values among ILKBSTVET students and recognition of previous achievements based on experience and achievement",
    description: "Description:",
    title1: "Makerspace Mybizhub",
    content1:
      "Provide space as well as technical training involving the field of entrepreneurship ( TVETPRENEUR) among youths and ILKBS graduates",
    title2: "Incubator Programme",
    content2:
      "Provide space and technical training involving the field of entrepreneurship , (TVETPRENEUR) among TVET ILKBS students",
    title3: "Modular Course",
    content3:
      "Short term skill training program over 3 to 6 months based on actual work processes",
    title4: "Recognition Of Past Achievements [PPT]",
    content4:
      "Provide and give recognition to national skilled workers who can prove the skills outlined in the National Occupational Skills Standard (SKPK) based on previous experience and achievements",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static agencyHrdfData = {
    hrdfTitle: "Human Resources Development Corporation (HRDCorp)",
    hrdfDescription:
      "HRD Corp has introduced 5 schemes focusing on marketability outcomes for existing and future employees as well as Malaysians who support economic growth.",
    description: "Description:",
    title1: "Place and Train",
    content1:
      "Initiatives to provide employment to youths, unemployed graduates and those who have been retrenched from work, through participation in training courses that provides added values that meets the needs of the industry as well as ensure job placement.",
    title2: "B40 Development",
    content2:
      "Initiatives to help the B40 group with specialized skills and knowledge that enable them to increase household income from various economic activities",
    title3: "SME Development",
    content3:
      "A structural training that is being held with the support from various strategis parties and agencies to help SME’s increase productivity to remain competitive in the market",
    title4: "Industrial Revolution 4.0",
    content4:
      "To assist employers to train their employees in training programmes related to digitization and be in the know and being current of the industry 4.0 to increase their knowledge of acquiring faster and more flexible design processes that could improve the speed of innovation that is consumer centered.",
    title5: "Gerak Insan Gemilang",
    content5:
      "Gig is aimed at facilitating Malaysians especially the youths with specific skills and knowledge through end to end training which could enable them to become freelancers to generate better income.",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static agencyEcerData = {
    ecerTitle: "East Coast Economic Region Development Council (ECERDC)",
    ecerDescription:
      "Offers human capital programmes designed for job placement or income generation concentrated in the East Coast Corridor Economic Region",
    title1: "ECER Talent Enhancement Program (ETEP):",
    titleContent1: "Place and Train",
    content1:
      "Companies will be assisted through the payment salary subsidy in the form of reimbursement basis repayment to enable new employees who have been hired to undergo training while working",
    title2: "ETEP Enhanced Train & Place (PENJANA)",
    content2:
      "The initiative to provide technical skills training opportunities to the target group to improve their personal skills and job marketability, is followed by a matching workforce between the company and the participants",
    description: "Description:",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static agencyNciaData = {
    nciaTitle: "Northern Corridor Implementation Authority (NCIA)",
    nciaContent:
      "Offers a human capital program designed for job placement or income generation concentrated in the Northern Corridor Economic Region",
    description: "Description:",
    title1: "JomNiaga@NCER",
    content1:
      "JomNiaga@NCER is an inclusive human capital program that can improve the living standards of the B40 group in the Northern Corridor Economic Region (NCER) through training in basic skills, entrepreneurship and e-commerce.",
    title2: "JomKerja@NCER",
    content2:
      "JomKerja@NCER is a human capital program designed for companies in the Northern Corridor Economic Region (NCER)to provide employment opportunities to unemployed workers and school leavers.",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static agencyMaraData = {
    maraTitle: "MARA",
    maraDescription:
      "Provide exposure and awareness through training and skills as well as educating the participants to cultivate various entrepreneurship values, and choosing the entrepreneurship as their career choice",
    description: "Description:",
    title1:
      "Building Internal Entrepreneur Capabilities by Engaging e-Commerce Bespoke Program (e-entrepreneur) -Training e-Commerce Platform",
    content1:
      "Enhance existing business capabilities to entrepreneurs using e-commerce platforms",
    title2:
      "Building Internal Entrepreneur Capabilities by Engaging e-Commerce Bespoke Program (e-entrepreneur) –Bespoke",
    content2:
      "Generate new revenue and increase existing ones in applications available in the market",
    title3:
      "Building Internal Entrepreneur Capabilities by Engaging e-Commerce Bespoke Program (e-entrepreneur) – Accelerator",
    content3:
      "Enhance the digital capabilities of entrepreneurs through the support of structured digitization systems",
    title4:
      "Building Internal Entrepreneur Capabilities by Engaging e-Commerce Bespoke Program (e-entrepreneur) -Technical GIG / e-Hailing",
    content4:
      "Enhance existing business capabilities to entrepreneurs using e-hailing platform",
    title5:
      "Building Capabilities and Providing Jobs Through Industry Boot Camp",
    content5:
      "Participants gain certification of competence to meet the requirements of positions in the industry",
    title6:
      "Building Capabilities and Providing Jobs Through Competencies / Short Courses Program",
    content6:
      "Participants receive the necessary training to meet the requirements of positions in the industry",
    title7: "TVET Community Programme",
    content7:
      "Skill training in areas that can generate online business income for local entrepreneurs promoting their products",
    title8:
      "Pembangunan Usahawan Menggunakan Kaedah Digital / Online Marketing (Mahir Niaga)",
    content8:
      "Online business to local entrepreneurs to promote their products",
    title9:
      "Pusat Sehenti Pengumpulan dan Pengedaran Produk Makanan Sejuk Beku",
    content9: "A one stop centre to store and market frozen food products",
    title10:
      "Safety Special Module and Health Care In The New Normal Environment",
    content10:
      "Special modules of new healthcare and safety habits in various sectors of the economy and skill areas",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };

  public static registerCardData = {
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
  };
  public static contactUsData = {
    title: "CONTACT US",
    titleDescription: "Have an enquiry or feedback for us? Contact us at our headquarter or branch offices here",
    yourName: "Your Name",
    yourEmail: "Your Email",
    subject: "Subject",
    yourMessage: "Your Message",
    sendMessageButton: "Send Message",
    doYouNeed: "Do you need any Assistance from our Officer?",
    callUs: "Call Us",
    pleaseContactUs: "Email Us",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
    start: "Start your upskilling journey today",
    contact: "Contact",
    contact1: "Contact",
    us: "Us",
    need: "Need",
    assist: "assistance?",
    noCourse: "No Course Found",
    slots: "Slots",
    courses: "Courses",
    search: "Search for courses here",
    courseDetails: "Course Details",
    startDate: "Starts",
    endDate: "Ends",
    certificate: "Certification",
    mode: "Training Methodology",
    state: "State",
    agency: "Agency",
    pic: "PIC Name",
    number: "Contact Number",
    email: "Email",
    related: "Related Courses",
    trainers: "Trainer(s)",
    duration: "Starts",
    enroll: "ENROL NOW",
    content: "Course Content",
    summary: "Course Summary",
    trainingType:"Training Type",
    skillArea:"Skill Area",
    contactNum: "Contact",
    back: "Go back",
    regopensoon:"Registration will open soon",
    hours: "Hours",
    trainingprovider: "Course Provider",
    coursetype: "Course Type",
    available_seats: "Available Seats",
    unlimited_seats: "Unlimited Seats",
    foc: "FREE",
    description: "Get In Touch and Let Us Know How We Can Help.",
    address: "Address",
    
  };

  public static insightsData = {
    insightsTitle: "REPORTS & ARTICLES",
    title: "Research and Development Industrial Report",
    description:
      "The Research and Development Industrial Report aims to provide information to the relevant Industries as well as general public on the latest development of Malayasian training landscape. The report also serves as references for both employers and employees on training needs.",
    tab1: "Training Digest",
    tab2: "Industrial Insights Report",
    tab3: "HRD Corp Quick Bite Report",
    tab4: "Learning And Workforce Ecosystem Reports",
    tab5: "Industry Training Participation (ITP) Report",
    registerNowCardText:
      "Want To Apply For A Training Programme?",
    registerNow: "Register Now",
    training: "The digest provides stakeholders with regular and succinct information on key developments within the training landscape",
    industry: "HRD Corp Industrial Insights Report aims to provide the stakeholders an understanding on the training trends and challenges faced by selected subsectors.",
    industyTitle: "Industrial Insights Report",
    capital: "Human Capital Report",
    capitalReport: "HRD Corp Human Capital Report aims to share the latest developments in human capital fields from HRD Corp perspective.",
    intelligence: "Industry Training Intelligence Report",
    intelligenceReport: "HRD Corp Industry Intelligence Report aims to provide human capital and learning ecosystem related information based on HRD Corp internal data and market movement.",
    itpReport: "Industry Training Participation (ITP) Report",
    itpDescription: "HRD Corp Industry Training Participation (ITP) Report aims to give stakeholders valuable insights on the landscape of training participation of various industries. It focuses on five (5) indicators: Effective Training Duration, Employees Trained Ratio, Training Opportunity Ratio, Training Places Approved, and Industry Investment on Training using the HRD Corp.",
    resources: "Resources",
    report: "Reports & Articles",
    tag: "Learn about the latest trends and  developments in your industry",
    research: "Research and Development",
    reports: "Reports",
    researchSub: "The reports provide extensive information on the latest trends and training needs for various industries. They also act as points of references for employers and employees.",
    trainings: "Training",
    digest: "Digest",
    start: "Start your upskilling journey today",
    download: "Download",
  };

  public static searchJobData = {
    jobSearch: "Job Search",
    recentJobListing: "Recent Jobs Listing",
    applyNow: "Apply Now",
    searchSkillsPH: "Search Skills , Job Title",
    jobTitle: "Job title",
    location: "Location",
    advanceSearch: "Advance Search",
    logout: "Logout",
    strategicPartners: "Strategic Partners",
    viewJobPost: "View Job Post",
  };

  public static employerSignupData = {
    heading: "My basic info",
    subHeading: "Sign up for FREE to find suitable candidates.",
    employName: "Employer Name",
    phoneNo: "Phone Number",
    placePhoneNo: "Enter Phone Number",
    emailAddress: "Email Address",
    createPassword: "Create Password",
    agreeRecive: "I agree to receive promos from HRD Corp.",
    agree: "I agree to HRD Corp's",
    terms: "Terms and Conditions",
    hrdf: "of HRD Corp.",
    getStarted: "Get Started",
    register: "Register",
    nonregister: "Non-Register",
    companyName: "Company Name",
    placeCompanyName: "Enter Company Name",
    companyRegNo: "Company Registration Number",
    placeCompanyRegNo: "Enter Company Registration Number",
    noOfEmpoly: "No of Employees",
    placeNoOfEmpoly: "Enter No of Employees",
    companySize: "Company Size",
    placecompanySize: "Company Size",
    companyInfo: "Company Info",
    placecompanyInfo: "Type Company Info",
    digitalUrl: "Digital Info/URL",
    placedigitalUrl: "Enter Digital Info/URL",
    industry: "Industry",
    placeIndustry: "Select Industry",
    address: "Address",
    placeAddress: "Enter Your Address",
    city: "City",
    placeCity: "Enter Your Location",
    state: "State",
    placeState: "Select State",
    postCode: "Postcode",
    placePostCode: "Enter Postcode",
    subSector: "Subsector",
    placeSubSector: "Enter Subsector",
    uploadLogo: "Upload Logo",
    placeUpload: "Upload Company Logo",
    createAccount: "Create Account",
  };

  //Jobseeker Dashboard
  public static jobSeekerDashboard = {
    profile: "Profile",
    editProfile: "Edit Profile",
    postedJob: "Posted Jobs",
    recomJob: "Recommended Jobs",
    appliedJobs: "Applied Jobs",
    interview: "Interviews",
    programs: "Available Programmes",
    courses: "Available Courses",
    recomCourse: "Recommended Courses",
    courseApplied: "Applied Courses",
    jobRecom: "Job Recommendations",
    recomCourses: "Course Recommendations",
    appliedCourseTitle: "Applied Courses",
    viewMore: "View More",
    Strategik: "Strategic Partners",
    allCourses: "All Courses",
    completed: "Completed Courses",
    noCourse: "No Available Course Found",
    noApplied: "No Applied Course Found",
    slots: "Slots",
    available_seats: "Available Seats",
    unlimited_seats: "Unlimited Seats",
    foc: "FREE",
    eLearning: "E-LEARNING",
    eLearningDesc: "More than 55,000 free courses are offered during NTW",
    ourCourse: "Our Course",
  };

  //jobseeker Profile Page

  public static jobSeekerProfile = {
    quickLink: "Quick Links",
    attachMent: "Attach Resume",
    uploadResume: "Upload Resume",
    format: "Supported Formats: pdf only, upto 2 MB",
    resumeHeadLine: "Resume Headline",
    keySkills: "Key Skills",
    employment: "Employment Details",
    addEmployment: "Add Employment",
    projects: "Projects",
    addProjects: "Add Projects",
    education: "Educational Background",
    addeducation: "Add Education",
    conditionQus: "Conditional Questions (For Course Matching)",
    addconditionQus: "Add Conditional Questions",
    profileSummary: "Profile summary",
    assessmentResult: "Skill Assessment",
    takeTest: "Take Test",
    jobPreferences: "Job Preferences",
    industry: "Industry",
    workPosition: "Work Position",
    jobCategory: "Job Category",
    employmentType: "Employment type",
    desiredShift: "Desired shift",
    personalDetails: "Personal details",
    dob: "Date of birth",
    gender: "Gender",
    maritalStatus: "Marital Status",
    city: "District/City",
    postcode: "Postcode",
    add: "ADD",
    update: "UPDATE",
    resumeDes: "Resume is the most important document recruiters look for.",
    attachVideo: "Attach Video",
    videoDes:
      "Supported Formats: MP4, WEBM, M4P, M4V, AVI, WMV, MOV, FLV and MPEG only, upto 30 MB",
    uploadVideo: "Upload Video",
    upload: "UPLOAD",
    personalityResult: "Personality Assessment",
    email: "Email address",
    phone: "Phone number",
    ic: "IC Number",
    profile: "Profile Summary",
    skills: "Skills",
    experience: "Experience",
    completed: "Completed Courses",
    personal: "Personal Details",
    notComplete: "No Completed Courses",
    passport : "Passport",
    ethnic : "Ethnicity"
  };

  //indSF

  public static industrialSkilsData = {
    headingINDSF: "INDUSTRIAL SKILLS",
    framework: "FRAMEWORK",
    overView: "OVERVIEW",
    overViewSub:
      "The Industrial Skills Framework (IndSF) is an initiative under the four main pillars of HRD Corp’s initiatives strategic map. It is placed under the learning ecosystem and landscape due to the nature of the document which is both non-exhaustive and promotes continuous learning cycle between employers, employees and potential job seekers. This document will be reviewed from time to time to meet the industry’s current needs in terms of core skills and competencies.",
    itCover: "WHAT DOES IT COVER?",
    itCoverSub:
      "IndSF focuses mainly on Level 4 Malaysian Skill Certification or equivalent and above as a complimentary document to existing frameworks such as National Occupational Skills Standard",
    whoIsItFor: "WHO IS IT FOR?",
    employee: "INDIVIDUALS / EMPLOYEES",
    employeeSubContent:
      "Individuals in their early and/or mid-career can use the Skills Framework to make informed decisions on education and training, career development and skills upgrading based on the sector, employment, occupation/job roles, skills and training information in the framework.",
    employers: "EMPLOYERS",
    employersSubContent:
      "Employers can use the Skills Framework to design progressive human resource management and talent development plans based on the detailed skills information in the framework.",
    agency: "AGENCY/ TRAINING PROVIDER",
    agencySubContent:
      "Training Providers can use the Skills Framework to gain insights into sector trends and skills in demand, which allow them to innovate and contextualise their curricular design and training programmes to suit the needs of the sector.",
    componentsTitle: "COMPONENTS",
    jobSkills: "JOB & SKILLS DESCRIPTION",
    jobSkillsSubContent:
      "The Skills Map details the skills for each of the industry’s occupations, aligned to the critical area / focus area/ department / sections. It provides information such as occupation description and skills)",
    careerPathway: "CAREER PATHWAYS",
    careerPathwaySubContent:
      "The Career Pathways show how the occupations in the Industrial Skills Framework for industry are structured progressively and laterally based on sector norm",
    trainingProgrammes: "TRAINING PROGRAMMES",
    trainingProgrammesSub:
      "The Training Programmes provide information on skills acquisition that are available for new entrants and in-service personnel to acquire skills and competencies required for various occupations in the Industry.",
    indSFSectors: "IndSF by Sectors:",
    plastics: "Plastics",
    machineryEquipment: "Machinery & Equipment",
    dataScience: "Digital Talent: Data Science",
    cybersecurity: "Digital Talent: Cybersecurity",
    games: "Digital Talent: Games",
    animation: "Digital Talent: Animation",
    frontOffice: "Hospitality: Front Office",
    housekeeping: "Hospitality: Housekeeping",
    revenueManagement: "Hospitality: Revenue Management",
    salesMarketing: "Hospitality: Sales & Marketing",
    hotel: "Hospitality: Hotel & General Manager",
    oilGas: "Oil, Gas & Energy",
    wholesaleRetail: "Wholesale & Retail",
    resource: "Resource",
    skill: "Industrial Skills Framework",
    develop: "Develop in-demand talents for industry needs",
    over: "Over",
    view: "view",
    overViewSub2: "The Industrial Skills Framework (IndSF) is a series of documents developed by HRD Corp in collaboration with industry partners to identify in-demand skillsets and competencies for various industries.",
    area: "Areas",
    covered: "Covered",
    areaSub: "IndSF focuses on Level 4 Malaysian Skills Certification or its equivalent and above. It also acts as a complementary document to existing frameworks such as the National Occupational Skills Standard (NOSS).",
    target: "Target",
    audience: "Audience",
    individual: "Individuals and Employees",
    individualSub: "Make informed decisions about education and certification pathways, while also identifying training and upskilling required for career development.",
    employer: "Employers",
    employerSub: "Design progressive human resource management programmes, as well as develop succession planning and career roadmaps for current and future employees.",
    training: "Training Providers",
    trainingSub: "Gain insights into sector trends and required skillsets in order to innovate and enhance programmes to meet talent and industry needs.",
    key: "Key",
    component: "Components",
    job: "Job & Skills Description",
    jobSub: "This outlines the required skills for each of the industry’s occupations. These are aligned to critical areas, focus areas, departments or sections. It also  provides detailed job descriptions for each role.",
    career: "Career Pathways",
    careerSub: "This highlights how occupations within the document are structured progressively and laterally based on sector norms as well as experience and required competencies.",
    programme: "Training Programmes",
    programmeSub: "This provides information on the kind of training programmes, certification levels and duration available for various roles within the industry.",
    sectors: "by Sectors",
    start: "Start your upskilling journey today",
    registerNow: "Register Now",
  };

  public static mediaGallery = {
    mediaGalleryTitle: "MEDIA GALLERY",
    video: "VIDEOS",
    publication: "PUBLICATIONS",
  };

  public static jobseekerLoginData = {
    welcome: "Welcome back!",
    pleaseLoginHeading: "Please log in with the individual data you entered during registration.",
    pleaseLoginHeading2: "Registered ",
    pleaseLoginHeadingWith: "jobseeker/ user in HPC/ Upskill/ MYHRDCORP Super App Platform ",
    pleaseLoginHeading3: "can login using existing credentials.",
    email: "Email Address",
    password: "Password",
    ic:'IC',
    enterPassword: "Enter Password",
    enterIC: "Enter IC",
    forgotPassword1: "Having trouble signing in? ",
    forgotPassword: "Click here.",
    login: "Login",
    dontHaveAccount: "Do not have an Individual account?",
    joinNow: "Join now",
    needHelp: "Need help?",
    contactUs: "Contact Us",
    empowering: "Empower yourself with continuous skills development.",
    // emailPlace: "sample@email.com",
    emailPlace: "Email Address",
    forgot: "Forgot Password",
    send: "Send Mail",
    credentials: "Registered jobseeker/user in HPC/Upskill/MyHRDCORP Super App platform can login using existing credentials.",
    continueWith: "or continue with",
  };

  public static employerLoginData = {
    pleaseLoginHeading: "Please Login to your account",
    email: "Email Address",
    password: "Password",
    enterPassword: "Enter Password",
    forgotPassword: "Having trouble signing in?",
    login: "Login",
    dontHaveAccount: "Do not have an Employer account in UpskillMalaysia?",
    joinNow: "Join now",
    needHelp: "Need help?",
    contactUs: "Contact Us",
    register: "Register",
    nonregister: "Non-Register",
  };

  public static innerpageData = {
    bannerText: "Pursue Your Dream Career By Choosing A Structured Training Program That Suits You",
    bannerTextsub: "Simple and Easy",
    courseSearch: "Course Search",
    first: "Take Your First Step",
    register: "Register",
    info: "Fill in the information",
    search: "Start the search",
    apply: "Apply",
    personalInfo: "Complete personal information and see how courses and careers match help through recommendations that suit your unique interests and needs.",
    find: "WANT TO APPLY FOR A TRAINING PROGRAMME?",
    registerNow: "Register Now",
    viewAll: "View All Courses",
    location: "Select Location",
    category: "Select Categories",
    skills: "Select Skills",
    applyNow: "Enrol Now",
    viewDetails: "View Details",
  };

    // Jobseeker profile Employment Form

    public static employmentformText = {
      addemployment: "Add Employment ",
      editemployment: "Edit Employment ",
      designation: "Your Designation ",
      designationplaceholder: "Your Designation",
      organization: "Your Organization ",
      organizationplaceholder: "Your Organization",
      positionlevel: "Position Level ",
      positionlevelplaceholder: "Select your Position",
      specialization: "Specialisation ",
      specializationplaceholder: "Select Specialisation ",
      role: "Role",
      roleplaceholder: "Select Role",
      jobcatagory: "Job Category",
      jobcatagoryplaceholder: "Select your Job Category",
      typesofjob: "Types of Job",
      typesofjobplaceholder: "Select your Job Type",
      currentcompany: "Is this your current company?",
      yes: "Yes",
      no: "No",
      startdate: "Started Working From",
      enddate: "Worked Till",
      monthlysalary: "Monthly Salary ",
      location: "Location",
      locationplaceholder: "Enter your location",
      state: "State",
      stateplaceholder: "Select State",
      outsidemalaysia: "Outside Malaysia",
      jobprofile: "Describe your Job Profile",
      typehere: "Type here",
      noticeperiod: "Notice Period",
      noticeperiodplaceholder: "Select Notice Period",
      industry: "Industry",
      industryplaceholder: "Select Industry",
      cancelbtn: "Cancel",
      savebtn: "Save",
      updatebtn: "Update",
      retrenched: "I have been retrenched",
    };

  // Jobseeker Profile Education Form
  public static educationformText = {
    addEducation: "Add Education",
    selecteducation: "Select Education",
    educationqualification: "Highest Educational Qualification",
    educationsubcatagory: "Education Sub Category",
    educationsubcataselect: "Select Education Category",
    fieldOfStudy: "Field of Study",
    selectfieldofstudy: "Select Field of study",
    university: "University/College/Polytechnic/Vocational/Skills Training Institution/School",
    enterunicollege: "Enter your University/College/Polytechnic/Vocational/Skills Training Institution/School",
    specialisation: "Specialisation",
    selectspecial: "Select Specialisation",
    specialisationsubCatagory: "Specialisation-sub category",
    selectspecialcata: "Select Specialisation Category",
    courseType: "Course Type",
    select: "Select",
    graduationTime: "Graduation Month/Year",
    gradingsystem: "Grading System",
    selectgradsystem: "Select Grading System",
    cgpamark: "CGPA/Grade/Mark",
    entercgpa: "Enter CGPA/Grade/Mark",
    cancelbtn: "Cancel",
    savebtn: "Save",
    fulltime: "Full Time",
    parttime: "Part Time",
    distancelearning: "Distance Learning",
    editeducation: "Edit Education",
    updatebtn: "Update ",
  };

  // Persona Detail Form Jobseeker

  public static personaldetailtext = {
    personaldetailheader: "Personal Details",
    dateofbirth: "Date of Birth",
    gender: "Gender",
    male: "Male",
    female: "Female",
    address: "Address",
    city: "City",
    state: "State",
    postcode: "Postcode",
    ethnicity: "Ethnicity",
    maritalstatus: "Marital Status",
    cancelbtn: "Cancel",
    savebtn: "Save",
    successalerthead: "Success",
    successalert: "Your personal details have been updated",
    dob: "Date of Birth",
    adPlaceholder: "Enter Address",
    cityPlaceholder: "Enter District/City",
    statePlaceholder: "Select State",
    postcodePlaceholder: "Enter Postcode",
    ethnicityPlaceholder: "Select Ethnicity",
    statusPlaceholder: "Select Status",
  };

  public static popupText = {
    success: "Success",
    error: "Error",
    addEmployeeSuccess: "Your registration is completed",
    addEmployeeFail: "Your registration is incomplete; please try again ",
    updateJobseekerSuccess:
      "This account has been linked with the employee successfully. ",
    updateJobseekerFail: "This account is not link with employee.",
    addEmployerSuccess: "Employer has been added successfully in the list",
    addEmployerFail:
      "Employer has not been added in the list, please try again.",
    addJobPostSuccess: "Job has been posted successfully",
    addJobPostFail: "Job post has not been posted, please try again.",
    advanceSearchError: "Please enter the keyword.",
    advertisementUploadSuccess: "Advertisement has been uploaded",
    advertisementUploadErr: "Advertisement has not been uploaded.",
    advertisementUploadErrFile: "File size should not be more than 1MB",
    advertisementUploadErrFileFrmt:
      "Ad only accepts jpg, jpeg and png file format",
    errFileSize2MB: "File size should not be more than 2MB.",
    errFileSize30MB: "File size should not be more than 30MB.",
    editEmployerErrFileFrmt: "Logo only accepts jpg, jpeg and png file format.",
    updateEmployerSuccess: "Employer profile updated.",
    updateEmployerErr: "Employer profile not updated.",
    updateJobPostSuccess: "Job Post updated successfully.",
    updateJobPostErr: "Job Post not updated.",
    invalidCredential:
      "Invalid credentials, please check your password and username",
    usernotfound: "User not found!!",
    couldnotlogin: "Could not Login… ",
    onlyIndLogin: "Only individuals could be login…",
    accntdeactivated:
      "Your account has been De-activated. Kindly contact admin.",
    accntActivateEmail: "Kindly activate your account through E-mail.",
    updateEmployerStatusSucess: "Employer status is updated successfully.",
    updateEmployerStatusErr: "Employer status is not changed.",
    logoUploadFileSizeErr: "File size should not be more than 2MB",
    logoUploadFileFrmt: "Logo only accepts jpg, jpeg and png file format.",
    createEmployerSuccess: "Your Registration has been done successfully.",
    createEmployerErr: "Employer not registered.",
    inviteCandidateForJobSuccess:
      "Invite to the job successfully.candidate will be notified soon",
    inviteCandidateForJobNotInvite: "Does not invite to the job",
    inviteCandidateForJobChoose: "Please choose  a job invitation.",
    noconditionalquestions:
      "No conditional questions provided for this course.",
    applycourseemploye: "Course applied to the employees.",
    unabletoprocess:
      "We are unable to process the application. Please try again.",
    selectEmployee: "Kindly select employee to apply.",
    maxemployee: "Only maximum 100 employees could be applied. ",
    resumeUploadFileSize: "File size is exceed. ",
    resumeUploadFileFrmtXlsx: "Resume accepts only xlsx file format. ",
    resumeUploadFileFrmtPdf: "Resume accepts only pdf file format. ",
    uploadEmployeeExceedLimit:
      "Kindly upload the files with total number of rows should not exceed 100. ",
    uploadEmployeeExceedSuccess: "Employees uploaded successfully.",
    deletejobPostsSuccess: "Job Post deleted successfully.",
    deletejobPostsErr: "Job Post not deleted. ",
    updatePostjobStatusSuccess: "Job Post status changed successfully.",
    updatePostjobStatusErr: "Job Post status not changed.",
    jobseekerDeactivates: "This jobseeker is de-activated. ",
    coudlnotreset: "Could not reset the password. ",
    updatePasswordEmployerSuccess: "Employer password updated.",
    updatePasswordEmployerErr: "Employer password not updated. ",
    resetEmployerPassword: "Could not reset the password. ",
    applyJobpostByJobseekerSuccess:
      "Job application has been successfully submitted to employer.",
    applyJobpostByJobseekerPosClosed:
      "We regret to inform that the position above has been closed in our system. We would like to congratulate those who have been hired for this position. ",
    applyJobpostByJobseekerErr: "Job has not been applied.",
    saveJobSuccess: "Job saved successfully.",
    saveJobErr: "Job unsaved successfully.",
    interviewScheduleAccept:
      "Interview schedule accepted successfully. You will be notified soon.",
    interviewScheduleDecline: "The interview schedule has been declined.",
    interviewScheduleNtAccept: "Interview schedule not accepted.",
    interviewScheduleNtRej: "Interview schedule not rejected.",
    uploadPdfFrmt: "Please upload only pdf file format",
    resumeuploaded: "Your resume has been uploaded",
    resumenotupdated: "Resume not updated ",
    resumefilefrmts:
      "Resume accepts only MP4, WEBM, M4P, M4V, AVI, WMV, MOV, FLV and MPEG file format ",
    videouploadedsuccess: "Your video has been uploaded successfully ",
    videouploaderr: "Video upload unsuccessful ",
    empdtlsdelsuccess:
      "Your employment details has been deleted in the profile ",
    empnotdel: "Employment not deleted ",
    edudtlsdeleSuccess:
      "Your education details has been deleted in the profile ",
    educationnotdel: "Education not deleted ",
    conditonalqnsdelsuccess: "The conditional questions have been deleted ",
    conditonalqnsntdel: "Conditional questions not deleted ",
    projdtlsdelsuccess: "Your project details has been deleted in the profile ",
    projntdel: "Project not deleted ",
    statusupdatedsuccess: "Status updated successfully ",
    statusntupdate: "Status not updated ",
    registrationntsuccess:
      "Your registration is not successful, please try again ",
    registrationsuccess: "Your Registration has been done Successfully. ",
    uploadfrmts: "Please upload only jpg, jpeg and png file format ",
    hrregsuccess: "HR user has been registered successfully ",
    hrntreg: "HR user has not been registered ",
    empntreg: "Employer not registered ",
    uploadxlsxfrmt: "Please upload only xlsx file format ",
    employeentupload: "Employees not uploaded ",
    couldntgtemail:
      "Could not get email-id from your account. Please try again with another account ",
    accountntreg: "Given account is not registered in HRD Corp",
    emailsntsuccess: "Mail Sent to Employer Successfully!! ",
    employerdelsuccess: "Employer is deleted successfully ",
    employerntdel: "Employer is not deleted successfully ",
    employerntdenied: "Employer has not been Denied ",
    employerntapprov: "Employer has not been Approved ",
    employerdenied: "Employer has been Denied Successfully ",
    employerapprov: "Employer has been Approved Successfully ",
    candidateuploaderr: "Candidates Upload Failed ",
    candidateuploadsuccess: "Candidates Uploaded Successfully ",
    jspassswdntupd: "Jobseeker Password not updated ",
    compprof: "Please complete your profile before proceeding ",
    crseapplied: "Course Applied",
    onecrseattime:
      "You can apply for only one course at a time. Please wait for the status update from Agency. Thank you.",
    anscondqns: "Kindly answer the Conditional Questions in your profile.",
    updcareercoachsucc:"Career Coach Updated Successfully",
    updcareercoacherr:"Career Coach has not been Updated",
    addcareercoachsucc:"Career Coach Created Successfully",
    addcareercoacherr:"Career Coach has not been Created",
    loginTitle: "Welcome back, please login your account.",
    emailId: "Email Address",
    password: "Password",
    emailPlaceholder: "sample@email.com",
    passwordPlace: "Password",
    forgotPassword: "Forgot Password",
    donothaveAccount: "Don’t have an account yet?",
    loginBtn: "Login",
    joinNow: "Join Now",
    needHelp: "Need help ? ",
    contactUs: "Contact Us",
    invalidCredentails: "Invalid credentials, please check your email and password",
    notApprovedYet: "Your account has not been approved yet !",
    myBasicInfo: "My Basic Info",
    steps: "Step 1 of 2",
    signupfree: "Sign Up for Free",
    name: "Name",
    namePlace: "Enter Name as per NRIC",
    nameErr: "The Name field is required",
    mobileNum: "Mobile Number",
    mobileNumPH: "Enter your phone number",
    mobileNumErr: "The Mobile Number field is required",
    icNumberErr: "The IC Number field is required",
    icNumberErr2: "IC Number Already Exists!",
    address: "Address",
    addressPH: "Enter Address",
    addressErr: "The Address field is required",
    emailErr: "The Email ID field is required",
    emailErr2: "Email-ID Already Exists!",
    city: "District / City",
    cityPH: "Enter District / City",
    cityErr: "The City field is required",
    state: "State",
    statePH: "Select State",
    stateErr: "The State field is required",
    postCode: "Postcode",
    placePostCode: "Enter Postcode",
    postCodeErr: "The Postcode field is required",
    step2: "Step 2 of 2",
    currentCompany:"Current Company: ",
    currentCompanyPH: "Enter your Current Company Name",
    specialization: "Specialization: ",
    specializationPH: "Select Specialization",
    specializationErr: "The specialization field is required",
    jobDesignation:"Job Designation: ",
    jobDesignationPH: "Enter your Job Designation",
    profilePic: "Profile Picture: ",
    profilePicError: "Kindly Upload your Profile Picture",
    motivation: "Short Description and your motivation for career coaching: ",
    motivationErr: "The Short Description field is required",
    certificate: "Related certification in Coaching / Training: ",
    certificatePH: "Certification / Training",
    certificateUpload: "Upload Certificates: ",
    certificates: "Certificates",
    slots: "Total Slots: ",
    slotsPH: "Number of Slots at a Time",
    slotsErr: "Total Slots Field is required", 
    firstP: "HRD Corp Career Coaching caters to job seekers of all ages from school leavers to unemployed graduates to retrenched workers.",
    secondP: "Are you confident in coaching job seekers, especially retrenched workers who have extensive work experience and are much older than the demographics of school leavers and unemployed graduates?",
    yes: "Yes",
    no: "No",
    concern: "Kindly explain your concerns and qualms.",
    concernErr: "The concern field is required",
    conditionErr: "Terms and Condition field is required",
    language: "Languages",
    selectErr: "Please Choose At least One language",
    availability: "Availability:  ",
    daysErr: "Please Choose Atleast One Day",
    time: "Time From",
    timeErr1: "Please Choose Time From",
    timeTo: "Time To",
    timeErr2: "Please Choose Time To",
    resume: "Upload Profile/Resume",
    uploadErr: "Kindly Upload Resume",
    confirmationCareerCoach: "Kindly proceed if the entered details are correct?",
    days: "Days:",
    chooseBtn: "Choose",
    createAccount: "Create Account",
    backBtn: "Back",
    getStartedBtn: "Get Started",
    add: "Add",
    enterDetails: "Enter details to Register",
    reserveBtn: "Reserve my spot",
    mydetails: "My Details",
    careerDetails: "My Career Details",
    languagesAble: "What languages are you able to do career coaching?",
    cancel: "Cancel",
    nextbtn: "Next",
    updateDone: "Update Profile",
    confirmation: "Confirmation",
    uniqueIdErr: "Email, Nric number and Mobile number should be unique",
    alert: "Alert",
    ok: "OK",
    inprogress: "Jobseeker has inprogress application",
    slotNotAvailable: "There is no slots available for this careercoach",
    ccNotApplied: "Career Coach has not been Applied",
    yourAppInProgress: "Your Application is already in Progress",
    successApplied: "Career Coach Applied Successfully",
    slotsNotAvailable: "There is no slots available for this careercoach",
    statusChange: "CareerCoach status Changed Successfully",
    jobseekerAssigned: "Jobseeker Assigned Successfully.",
    applicationNotupdated: "Application has not been assigned.",
    deleteSuccess: "CareerCoach Deleted Successfully",
    notDeleted: "CareerCoach status has not been Deleted",
    sessionSchedule: "Session Schedule Accepted Successfully.",
    sessionRejected: "Session Schedule has been Rejected.",
    sessionNotUpdated: "Session Schedule  has not been Updated.",
    jobseekerCoached: "Jobseeker Coached",
    jobseekerApplied: "Jobseeker Applied",
    select: "Select",
    close: "Cancel",
  };

  public static courseListData = {
    courses: "Courses",
    courseTag: "Improve your knowledge in your preferred skill area",
    search: "Search for courses here",
    skillArea: "Skill Areas",
    sortby: "Sort by",
    filterby: "Filter by",
    accounting: "Accounting & Finance",
    statistics: "Actuarial or Statistics",
    admin: "Administration or Clerical",
    tax: "Audit or Tax",
    aviation: "Aviation",
    chemistry: "Biotechnology or Chemistry",
    more: "More",
    training: "Course Providers (from A to Z)",
    courseTitle: "Course Titles (from A to Z)",
    courseDuration: "Course Duration (from shortest to longest)",
    courseAvailability: "Course Availability",
    courseFee: "Course Fee (from lowest to highest)",
    startDate: "Course Start Date",
    all: "All",
    partnership: "In partnership with",
    applyCourse: "Applied Courses",
    applied: "APPLIED",
    applyNow: "ENROL NOW",
    pending : "Pending",
    approved: "Approved",
    reject: "Rejected",
    progress: "In Progress",
    withdraw: "Withdraw",
    completedPlaced: "Completed and Placed",
    genCert: "Generate Certificate",
    teeAssessment: "TEE Assessment",
    applied1: "Applied",
    first: "Newest First",
    trainingPlaceholder: "Select",
    completed:"Completed",
    noCourse: "No Course Found",
    noApplied: "No Applied Course Found",
    clear: "Clear",
    slots: "Slots",
    mode: "Training Mode",
    location: "Location",
    trainingC: "Training Certification",
    courseType: "Course Type",
    cpsearch: "Search for course providers here",
    courseProviders: "Course Providers",
    pillarfocus: "Pillars & Focus Areas",
    archived_courses: "Archived Courses",
    skill_areas: "Skill Areas",
    available_seats: "Available Seats",
    unlimited_seats: "Unlimited Seats",
    foc: "FREE",
    level: "Level",
    satelliteEvents: "Satellite Events",
    searchSatellite: "Search for Satellite Events here",
    enrolments: "Enrolments",
    findOutMore: "Find Out More",
    viewCert: "View Certificate",
    startDatePlaceholder: "Select Start Date",
    selectPillar: "Select a Pillar & Focus Area",
    selectSkill: "Select a Skill Area",
    selectSort: "Select Sorting Option",
    hour: "Hour",
    hours: "Hours",
    totalHour: "Total Hour",
    totalHours: "Total Hours",
    preSchool: "Pre-school Children",
    teenagers: "Teenagers",
    adult: "Young Adults and University Students",
    graduates: "Graduates",
    professionals: "Professionals",
    seniors: "Senior Citizens",
    openToAll: "Open To All",
    oldestFirst: "Oldest First",
    newestFirst: "Newest First",
    oldest: "Oldest",
    newest: "Newest",
    onlineTraining: "Online Training",
    visited : "Visited"
  }

  public static courseDetailsData = {
    courses: "Courses",
    search: "Search for courses here",
    courseDetails: "Course Details",
    startDate: "Starts",
    endDate: "Ends",
    certificate: "Certification",
    mode: "Training Methodology",
    state: "State",
    agency: "Agency",
    contact: "Contact",
    pic: "PIC Name",
    number: "Contact Number",
    email: "Email",
    related: "Related Courses",
    slots: "Slots",
    trainers: "Trainer(s)",
    duration: "Starts",
    enroll: "ENROL NOW",
    content: "Course Content",
    summary: "Course Summary",
    noCourse: "No Course Found",
    trainingType:"Training Type",
    skillArea:"Skill Area",
    hours: "Hours",
    regopensoon:"Registration will open soon",
    trainingprovider:"Course Provider",
    coursetype:"Course Type",
    foc: "FREE",
    available_seats: "Available Seats",
    unlimited_seats: "Unlimited Seats",
    joinNow: "Join Now",
    courseEnded: "Course ended",
    goNow: "Go Now",
    pillar: "Pillar",
    docReference: "Reference Document(s)",
    blendHybrid: "Blend / Hybrid",
    classRoom: "Classroom",
    coaching: "Coaching",
    eLearning: "e-Learning",
    onlineTraining: "Online Training",
    lifeSkill: "Life Skills",
    futureSkill: "Future Skills",
    creativityInnovation: "Creativity & Innovation",
    financial: "Financial",
    sustainableDev: "Sustainable Development",
    pleaseEnroll: "Please Login to Enroll a Course"
  }

  public static faqData = {}

  public static privacyData = {
    title: "PERSONAL DATA PROTECTION NOTICE",
    privacy: "Privacy Policy",
    p1: "National Training Week is committed to protect the privacy and security of any personal data that may be provided by an Individual, Employer, Course Provider and / or Ministries and Agencies (“Users”) that are collected during the National Training Week through any online questionnaires, forms and / or surveys.",
    p2: "This Privacy Notice aims to explain how your personal data is handled and protected and what the National Training Week's data protection obligations are along with your rights. When you share your personal data with us or when we collect your personal data, we use it in line with this Privacy Policy. Please read through this information carefully. If you have any queries and / or concerns about your personal data, please contact us via the contact details set out below.",
    title1: "1. Collection and Use of Personal Data",
    p3: "This Personal Data Protection Notice is issued to all our valued Users, pursuant to the requirements of the Personal Data Protection Act 2010 (“the Act”) and its regulations. Any personal data provided by the Users shall be protected in accordance to the Act and our security measures put in place to ensure the safety of your Personal Data.",
    p4: "We at National Training Week aim to treat and view all your personal data that has been disclosed and /or provided to us seriously. We strive to uphold all personal data provided to us with utmost integrity.",
    p5: "In the course of your dealings with National Training Week website (“website”) as our valued Users, we will request that you provide data and information about yourself (“Personal Data”) to enable us to better understand, cater and calibrate best suited results, details and / or information for you and / or to deliver the necessary notifications, notices, services and/or products. Your Personal Data enables us to achieve the purpose herein in connection with our website.",
    title3: "2. Nature of Personal Data",
    p6: "Such Personal Data may be subject to applicable data protection, privacy and other similar laws. Such Personal Data shall mean any information or pieces of information that could identify you either directly or indirectly and / or information which makes you identifiable. Amongst other, Personal Data may include information concerning name, age, identity card number, passport number, address, gender, date of birth, marital status, occupation, contact information, email address, race, ethnic origin and nationality.",
    title4: "3. Impact from failure to supply Personal Data",
    p7: "The failure to supply such Personal Data will result in us being unable to:-",
    descA: "provide you with the notices, services and/or programmes requested;",
    descB: "update you on our latest programmes, courses and services offered by the relevant government ministries and agencies;",
    descC: "recommend available courses and / or programmes best suited to your professional skills, experiences and qualifications.",
    title5: "4. Purpose of Collecting Personal Data",
    p8: "The Personal Data is collected, used and/or otherwise processed by us to enable Users to be part of the National Training Week, amongst others, the following purposes:",
    descAtitle5: "maintaining and updating internal record keeping; and",
    descBtitle5: "meeting any legal or regulatory requirements and making disclosure under the requirements of any applicable law, regulation, terms and conditions, direction, court order, by-law, guideline, circular, code applicable to National Training Week.",
    title6: "5. Disclosure of Personal Data",
    p9: "The Personal Data provided to us will generally be kept confidential but you hereby consent and authorize us to provide or disclose your Personal Data to the following categories:- ",
    descAtitle6: "any person to whom we are compelled or required to do so under law;",
    descBtitle6: "statutory authorities, government agencies and industry regulators; ",
    descCtitle6: "our partnering agencies under the purview of the relevant governmental agencies;",
    descDtitle6: "our consultants, accountants, auditors, lawyers or other financial or professional advisers;",
    descEtitle6: "our service providers for purposes of establishing and maintaining a common database where we have a legitimate common interest; and",
    descFtitle6: "any other categories deemed necessary by us.",
    title7: "6. Safeguards",
    p10: "We shall keep and process your data in a secure manner. We endeavour, where practicable, to implement the appropriate administrative and security safeguards and procedures in accordance with the applicable laws and regulations to prevent the unauthorized or unlawful processing of the Personal Data and the accidental loss or destruction of, or damage to, the Personal Data.",
    title8: "7. Rights of Access and Correction",
    p11: "In general, you are not required to submit any personal information to National Training Week, but for the purpose(s) that you have interacted with us on the website, we will require you to provide certain personal information for us to filter relevant details best suited for you.",
    p12: "In any event, you have the right to request for access to and correction of your information held by us and in this respect, you may:",
    descAtitle8: "check whether we hold or use your Personal Data and request access to such data; ",
    descBtitle8: "request that we correct any of your Personal Data that is inaccurate, incomplete or out-of-date; ",
    descCtitle8: "request that your Personal Data is retained by us only as long as necessary for the fulfilment of the purposes for which it was collected;",
    descDtitle8: "request that we specify or explain our policies and procedures in relation to data and types of Personal Data handled by us;",
    descEtitle8: "communicate to us your objection to the use of your Personal Data for marketing purposes whereupon we will not use your Personal Data for these purposes; and",
    descFtitle8: "withdraw, in full or in part, your consent given previously, in each case subject to any applicable legal restrictions, contractual conditions and a reasonable time period.",
    title9: "8. Links to Other Sites",
    p13: "Please take note that National Training Week's website may typically contain links to other sites that are not governed by this Privacy Policy. We encourage Users to review the privacy notice of each website visited before disclosing any personal information.",
    p14: "National Training Week will not be responsible for such third party sites. Any personal information made available by you on such sites will be subjected to the relevant third party's privacy policy (if any).",
    title10: "9. Consent ",
    p15: "Your usage of our website indicates your consent to the use and collection of your Personal Data in accordance with this Personal Data Protection Notice unless and until you inform us to the contrary herein. ",
    p16: "Your personal information may be disclosed due to reasons of law, legal process, litigation, and/or requests from public and governmental authorities and any disclosure will be to such public and governmental authorities only. We may also disclose information about you if we determine that disclosure is necessary or appropriate for purposes of national security, law enforcement, or other issues of public importance.",
    title11: "10. Contact Us",
    p17: "National Training Week is committed to protecting the online privacy of your personal information. If you have any questions or concerns regarding this Privacy Notice or would like further information about how we protect your personal data, please email us at taskforce@nationaltrainingweek.gov.my",
  }

  /**
   * Home page content (new)
   */
  public static homePageDataOverview = {
    // title: "ABOUT NATIONAL TRAINING WEEK (NTW) 2024",
    title: "Learning Beyond Borders",
    sub_title: "Inspiring Malaysian Excellence through Lifelong Learning",
    // desc_1: "Introduced in 2023, NTW is a full week of nationwide training events and activities bringing together organisations and people from various industries and backgrounds for learning and development opportunities.",
    // desc_2: "The training, which is conducted through various learning methods and platforms, is provided by local industry players for FREE to all Malaysians in many locations.",
    // desc_3: "This year, NTW 2024 is focused on enabling Malaysians to play an active role in advancing the nation's growth and well-being, going beyond the role of mere participants.",
    // desc_4: "Central to this objective is the emphasis on equipping individuals with the necessary skills and knowledge to excel in today's dynamic job market, instilling a culture of lifelong learning, and fostering collaboration among industries, academia, and individuals alike.",

    // desc_1: "In a world where change is the only constant, National Training Week (NTW) stands as a beacon of hope, offering free access to quality learning and development opportunities to people from all walks of life.",
    // desc_2: "This initiative is more than just a training carnival — it’s a nationwide movement to future-proof careers, bridge skills gaps, and ignite a culture of lifelong learning and skills enhancement.",
    // desc_3: "In collaboration with the Ministry of Human Resources (KESUMA), HRD Corp acts as a bridge - connecting the workforce with industry leaders, educators, and resources. NTW coincides with the ASEAN Year of Skills (AYOS) 2025, becoming one of its flagship initiatives.",
    // desc_4: "This exciting development means that NTW will extend its reach regionally, fostering an unparalleled partnership for the growth of skills and knowledge across ASEAN. Themed, Learning Beyond Borders, is in line with the spirit of AYOS 2025, as it promotes regional collaboration, inclusivity, and innovation.",
    // desc_5: "With thousands of training programmes, ranging from digital skills and green technology to leadership and advanced manufacturing, NTW is a one-stop hub for upskilling and reskilling. Whether you’re a fresh graduate, a mid-career professional, or an employer looking to elevate your team, NTW opens doors to opportunities that matter.",
    // desc_6: "What sets NTW apart is its accessibility. All programmes are offered at no cost, ensuring that no one is left behind in a journey toward a high-income, knowledge-driven economy. From bustling cities to remote villages, NTW’s hybrid model—combining in-person and online sessions—reaches thousands, transforming lives and livelihoods.",
    // desc_7: "NTW isn’t just a response to the skills crisis — it’s a solution. By empowering people with the tools and accessible learning opportunities to thrive in a fast-changing world, NTW is shaping a brighter, more competitive and future-ready workforce for all.",
    
    subtitle_1: "Overview​",
    subtitle_2: "Learn, Grow, Elevate​",
    desc_1: "National Training Week (NTW) aims to provide all Malaysians, regardless of background, with free access to quality learning and development opportunities.",
    desc_2: "Focused on lifelong learning and skills enhancement, NTW empowers individuals to thrive in an evolving economy. In collaboration with the Ministry of Human Resources (KESUMA), HRD Corp serves as a bridge, connecting the workforce with industry leaders, educators and valuable learning resources.​",
    desc_3: "In line with the Malaysia MADANI pillar of Kesejahteraan, the theme reflects HRD Corp’s commitment through NTW to empowering individuals with the skills and knowledge needed to enhance both economic security and quality of life.",
    desc_4: "By expanding access to learning opportunities, NTW supports the shared vision of building a more skilled, competitive and future-ready Malaysian workforce.​"

  };
  public static homePageDataObjectives = {
    // title: "OBJECTIVES",
    title: "Our Objectives",
    desc_1: "Make lifelong learning a culture for Malaysians",
    desc_2: "Increase strategic inter-government cooperation for training and development",
    desc_3: "Equip Malaysian talents with future work skills and knowledge",
  };
  public static homePageDataPillars = {
    // title: "PILLARS & FOCUS AREAS",
    title: "Pillars & Focus Areas",
    sub_title: "",
    pillar_1_title: "Life Skills",
    pillar_1_desc: "Personal Development and Self Actualisation",
    pillar_2_title: "Future Skills",
    pillar_2_desc: "STEM, TVET, Digitisation, AI & Machinery",
    pillar_3_title: "Creativity & Innovation",
    pillar_3_desc: "Music, Arts, Culture & Creative Education",
    pillar_4_title: "Financial",
    pillar_4_desc: "Banks, Insurance, Investment & Fin-Tech",
    pillar_5_title: "Sustainable Development",
    pillar_5_desc: "Environment, Development, Equality & Prosperity",
  };
  public static homePageDataTargetGroups = {
    // title: "TARGET GROUPS",
    title: "Target Groups",
    sub_title: "NTW will feature activities for Malaysians from all walks of life based on the following:",
    individuals: "Individuals",
    pre_school_children: "Pre-school Children",
    teenagers: "Teenagers",
    young_adults: "Young Adults and University Students",
    graduates: "Graduates",
    professionals: "Professionals",
    senior_citizens: "Senior Citizens",
    industry_players: "Industry Players",
    employers: "Employers",
    industry_associations: "Industry Associations",
    business_chambers: "Business Chambers",
    training_n_delivery_partners: "Training and Delivery Partners",
    online_providers: "Online Platform Providers",
    training_providers: "Trainers and Training Providers",
    academic_institution: "Academic Institutions",
    skill_based_institutions: "Skills-based Institutions",
    learning_centres: "Physical Learning Centres",
    tuition_centres: "Kindergartens and Tuition Centres",
  };
  public static homePageDataBenefits = {
    // title: "BENEFITS",
    title: "Our Benefits",
    // individual: "INDIVIDUAL", 
    individual: "Individual", 
    individual_desc_1: "Understand the importance of training in self-development.",
    individual_desc_2: "Increase self-confidence, motivation and productivity.",
    individual_desc_3: "Boost employment and career advancement opportunities.",
    // industry: "INDUSTRY",
    industry: "Industry",
    industry_desc_1: "Enable course providers to offer relevant courses based on the government's economic agenda.",
    industry_desc_2: "Raise employer awareness on the skills courses available to employees and prospective employees.",
    industry_desc_3: "Address skills gaps and recruit the right employees.",
    // nation: "NATION",
    nation: "Nation",
    nation_desc_1: "Assist the Government to achieve its 35% Skilled Workforce targets by 2030.",
    nation_desc_2: "Cultivate closer cooperation between state and federal government to strengthen human capital development initiatives.",
    nation_desc_3: "Attract greater foreign investment due to multiskilled and dynamic talents.",
  };
  
  public static homePageDataSocial = {
    title: "Social Wall",
  };

  public static footerDataNew = {
    text_1: "Disclaimer: HRD Corp shall not be liable for any loss or damage caused by the usage of any information obtained from this website.",
    text_2: "Copyright © 2023 HRD Corp All rights reserved", 
    text_3: "Safety and Privacy Policy",
  };
  public static courseSection = {
    viewall: "View All Courses",
  };
  public static onlineCourses = {
    // title: "E-LEARNING",
    title: "E-Learning",
    // subtitle: "More than 55,000 free courses are offered during NTW",
    subtitle: "Learn anytime, anywhere! Check out our trending courses.",
    subtitle2: "Take the first step. Explore, enhance and elevate your skills.",
    courses: "Courses",
  };
  
  public static trendingOnlineCourses = {
    title: "Trending E-Learning Courses",
  };
  
  public static achievementSection = {
    title: "Achievement Stages",
    subtitle: "As you complete training hours, you will earn badges to recognise your progress and achievements",
    total_training_hour : 'Total Training Hours' ,
    current_achivement : 'Current achievement status : To achieve ',
    highest_achievement : 'Highest achievement status : Achieved ',
    hour : 'hours',
    pioneer: "Pioneer",
    explorer: "Explorer",
    challenger: "Challenger",
    trailblazer: "Trailblazer",
    legend: "Legend",
    descPioneer: 'Starting the journey and taking the first steps.',
    descExplorer: 'Gaining the experince and expanding horizons.',
    descChallenger: 'Overcoming obstacle and pushing limits.',
    descTrailblazer: 'Achieving mastery and leading the way.',
    descLegend: 'Reaching the pinnacle of success and inspiring others.',

    locked: "Locked",
    unlocked: "Unlocked",
  };

  public static satelliteEvents = {
    // title: "SATELLITE EVENTS",
    title: "Satellite Events",
    subtitle: "Experience the power of learning at NTW’s satellite events—where local communities meet global opportunities.",
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    jun: "June",
    jul: "July",
    aug: "August",
    sept: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    search: "Search for event here",
    viewall: "View All",
  };

  public static resourceData = {
    resources: "Resources",
    individualGuideline: "Individual Guideline",
    tpGuideline: "Course Providers Guidelines",
    postTrainingCert: "Post Training Report & Certificate",
    brandGuideline: "Brand Guidelines",
    logoFullColor: "Logo NTW Full Color",
    logoBlack: "Logo NTW Black",
    logoGreenWhite: "Logo NTW Green White",
    logoWhite: "Logo NTW White",

  };
}